export const enum offerStatusEnum {
  Valid = 'valid',
  Selected = 'selected',
  Error = 'error',
}
